import axios from 'axios';
import React, { useEffect, useState } from 'react';
import placeholderLogo from '../../../static/images/logo/logo.png'

const Logo = () => {
  const style = {
    width: '45%',
    marginLeft: '2%',
    height: '80%'
  };

  const [logo, setLogo] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const getLogo = (retries = 4, interval = 1000) => {
    setLoading(true);
    setError(false);
    axios
      .get('api/logo/get')
      .then((response) => {
        setLogo(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        if (retries > 0) {
          setTimeout(() => getLogo(retries - 1, interval), interval);
        } else {
          setLoading(false);
          setError(true);
        }
      });
  };

  useEffect(() => {
    getLogo();
  }, []);

  if (loading) {
    return <div>CI 로딩중...</div>;
  }

  if (error) {
    return (
      <div className="headerLogo">
        {/* <img style={style} src={placeholderLogo} alt="Default Logo" /> */}
      </div>
    );
  }

  const src = `data:image/jpg;base64, ${logo}`;

  return (
    <div className="headerLogo">
      <img style={style} src={src} alt="Logo" onError={() => setError(true)} />
    </div>
  );
};

export default Logo;
